import { render, staticRenderFns } from "./DeviceWarning.vue?vue&type=template&id=c43d71a4&scoped=true&"
import script from "./DeviceWarning.vue?vue&type=script&lang=js&"
export * from "./DeviceWarning.vue?vue&type=script&lang=js&"
import style0 from "./DeviceWarning.vue?vue&type=style&index=0&id=c43d71a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43d71a4",
  null
  
)

export default component.exports